import type { CSSProperties, HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

interface TextShimmerProps extends HTMLAttributes<HTMLSpanElement> {
  children: string;
  duration?: number;
  spread?: number;
}

export function TextShimmer({
  children,
  className,
  duration = 1.8,
  spread = 26,
  style,
  ...props
}: TextShimmerProps) {
  return (
    <span
      data-text-shimmer
      data-text={children}
      className={cn("agent-text-shimmer relative inline-block", className)}
      style={
        {
          "--text-shimmer-duration": `${duration}s`,
          "--text-shimmer-spread": `${spread}%`,
          ...style,
        } as CSSProperties
      }
      {...props}
    >
      <span className="opacity-70">{children}</span>
    </span>
  );
}
